export const broadbandTypesTooltipTexts = {
  FIBRE:
    'Super fast fibre optic broadband means smoother video-streaming, better online gaming and quicker sharing of photos and videos.'
}
